// Contants
import { getLocalStorage } from '../../constants/others'

// Axios
import { serverAPI } from '../../index'

// Action types
export const CHANGE_AUTH = 'change_auth'
export const CHANGE_INVITED = 'change_invited'
export const CHANGE_FIRST_TIME = 'change_first_time'
export const CHANGE_USER = 'change_user'
export const CHANGE_USER_FIELD = 'change_user_field'
export const RELOAD_USER = 'reload_user'
export const RANDOM_IMAGE = 'random_image'
export const CHANGE_FORM_TYPE = 'change_form_type'
export const CHANGE_QRCODE = 'change_qrcode'
export const CHANGE_SETUP_TOKEN = 'change_setup_token'
export const SET_TOKEN = 'set_token'

export function changeAuth(status) {
  return {
    type: CHANGE_AUTH,
    payload: status
  }
}

export function changeInvited(status) {
  return {
    type: CHANGE_INVITED,
    payload: status
  }
}

export function setToken(token) {
  return {
    type: SET_TOKEN,
    payload: token
  }
}

export function changeFirstTime(status) {
  return {
    type: CHANGE_FIRST_TIME,
    payload: status
  }
}

export function reloadUser() {
  return {
    type: RELOAD_USER,
    payload: getLocalStorage()
  }
}

export function changeUserField(field) {
  return {
    type: CHANGE_USER_FIELD,
    payload: field
  }
}

export function fetchUserCompanies(companyId) {
  return function (dispatch) {
    return serverAPI.get('/user/companies')
      .then(response => {
        dispatch(changeUserField({ 'key': 'companies', 'value': response.data }))
      })
      .catch(_ => {})
  }
}

export function randomImage() {
  return {
    type: RANDOM_IMAGE
  }
}

export function changeFormType(type) {
  return {
    type: CHANGE_FORM_TYPE,
    payload: type
  }
}

export function changeQrcode(value) {
  return {
    type: CHANGE_QRCODE,
    payload: value
  }
}

export function changeSetupToken(setupToken, isNewSetup) {
  return {
    type: CHANGE_SETUP_TOKEN,
    payload: { setupToken, isNewSetup }
  }
}
